import { render } from "./Applicant_Preferences.vue?vue&type=template&id=4fa5f051&scoped=true"
import script from "./Applicant_Preferences.vue?vue&type=script&lang=js"
export * from "./Applicant_Preferences.vue?vue&type=script&lang=js"

import "./Applicant_Preferences.vue?vue&type=style&index=0&id=4fa5f051&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fa5f051"]])

export default __exports__